module.exports = ".block{margin-left:0}.scrollable-when-overflow{max-width:300px;overflow-x:auto}\n"